import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import AriImage from 'react-ari';

export class HeaderImageApp extends Component {

	static propTypes = {
		headerVariants: PropTypes.array,
		breakingNews: PropTypes.string,
		breakingNewsMobile: PropTypes.string
	};

	componentDidMount() {

	}

	insertMarkup(message) {
        return {__html: this.htmlspecialchars_decode(message)};
    }

    isMobileDevice() {
        return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
    }

    htmlspecialchars_decode = function(string) {
		const htmlspecialchars_decode_specialchars = [
            [ '"', '&quot;' ],
            [ '>', '&gt;' ],
            [ '<', '&lt;' ],
            [ '&', '&amp;' ]
        ];

		let unescapedString = string;
        let len = htmlspecialchars_decode_specialchars.length;
        for (let x = 0; x < len; x++) {

            // Replace all instances of the entity with the special character.
            unescapedString = unescapedString.replace(
                new RegExp(htmlspecialchars_decode_specialchars[x][1], 'g'),
                htmlspecialchars_decode_specialchars[x][0]
            );
        }

        return unescapedString;
    };

	render() {
		let {breakingNews, breakingNewsMobile} = this.props;
		const {headerVariants, breakingNewsType} = this.props;
		const randomIndex = Math.floor(Math.random()*headerVariants.length);
		const randomHeaderVariant = headerVariants[randomIndex];
		const file = randomHeaderVariant.image;

		// Fallback in case only one text is set in a hurry
		if(breakingNews === '' && breakingNewsMobile !== '') {
			breakingNews = breakingNewsMobile;
		}
        if(breakingNewsMobile === '' && breakingNews !== '') {
            breakingNewsMobile = breakingNews;
        }

		const breakingNewsText = this.isMobileDevice() ? breakingNewsMobile : breakingNews;

		return (
			<Fragment>
				<div className="header--media-image-text">
					<span>
                        {randomHeaderVariant.labelLink === '' ?
                            randomHeaderVariant.label :
                            <a href={randomHeaderVariant.labelLink}>
                                {randomHeaderVariant.label}
                            </a>
                        }
                    </span>
				</div>

				<AriImage
					id={file.id}
					name={file.name}
					hash={file.hash}
					cropHash={file.cropHash}
					title={file.title}
					alt={file.title}
                    maxwidth={file.maxwidth}
					respectheight="true"
				/>


				{randomHeaderVariant.ctaText !== '' || randomHeaderVariant.ctaLinkText !== '' ?
					<div className={"callToAction--element " + randomHeaderVariant.color}>
						<a href={randomHeaderVariant.ctaLink}>
							<div className="buttonText">
								<div dangerouslySetInnerHTML={this.insertMarkup(randomHeaderVariant.ctaText)}>

								</div>
								<div className="textPrio">{randomHeaderVariant.ctaLinkText}</div>
							</div>
						</a>
					</div>
					: ''
				}

				{breakingNews !== '' ?
					<div className={"breakingNews--wrapper container " + (randomHeaderVariant.breakingNewsNegative ? 'negative' : '')}>
						<div className={"breakingNews-element " + breakingNewsType} dangerouslySetInnerHTML={this.insertMarkup(breakingNewsText)}>

						</div>
					</div>
					: ''
				}

			</Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/apps/HeaderImageApp.js